import FullScreenLoader from "components/loaders/fullscreen";
import { parseTenant } from "lib/tenant";
import { FunctionComponent, ReactNode, useEffect } from "react";
import { fetchOrganization } from "stores/actions/organization";
import { useOrganization } from "stores/hooks/organization";

interface TenantProviderProps {
  children: ReactNode;
}

const OrganizationProvider: FunctionComponent<TenantProviderProps> = ({
  children,
}) => {
  // check from state
  const organization = useOrganization();

  // parse domain from url
  const tenant = parseTenant();

  // update organization data from the backend
  useEffect(() => {
    fetchOrganization();
  }, []);

  // in case we have a domain in the url, but no data then show nothing
  if (tenant && !organization) {
    return <FullScreenLoader />;
  }

  // the actual content in the end
  return children;
};

export default OrganizationProvider;
